import { CheckboxTheme } from '../../types';

export const CHECKBOX_DEFAULT_THEME: CheckboxTheme = {
    colors: {
        default: 'grey.base',
        checked: 'primary.base',
    },
};
